import {Media} from '@/models/Media'
import {Model} from '@/models/Model'
import {DataArray} from '@/models/Response'
import {User} from '@/models/User'
import Helper from '../services/Helper.js'


export const TimelineConst = Object.freeze({
  TYPE_COMMENT: 1,
  TYPE_STATUS: 2,
  TYPE_UPDATE: 3,
  TYPE_ATTACH: 4,


  map(status: number): string {
    switch (status) {
      case TimelineConst.TYPE_COMMENT:
        return 'คอมเม้น'
      case TimelineConst.TYPE_STATUS:
        return 'สถานะ'
      case TimelineConst.TYPE_UPDATE:
        return 'เปลี่ยนแปลง'

      //รอจัดทริป
      //กำลังขนส่ง
      //
    }
    // debugger
    return ''//'ไม่ระบุ[' + status + ']'
  },


  color(status: number): string {
    switch (parseInt(`${status}`)) {
      case TimelineConst.TYPE_COMMENT:
        return 'grey lighten-1'
      case TimelineConst.TYPE_STATUS:
        return 'grey lighten-1'
      case TimelineConst.TYPE_UPDATE:
        return 'blue-grey'
    }
    // debugger
    return ''
  },

})


export class Timeline extends Model {
  declare id: number
  created_at: Date | null
  updated_at: Date | null
  deleted_at: Date | null

  status: number | null

  recordable_type: string | null
  recordable_id: number | null

  order_id: number | null

  user_id: number | null
  user: User | null
  type: number | null
  content: string | { attachments: Media[];text: string; }
  mode: string | null

  getResourceURL(): string {
    return Helper.setting.timeline.getResourceAPI
  }


  async SetStatus(status: number): Promise<Timeline> {
    // debugger
    this.status = status
    return await this.save<Timeline>()
  }


}

export class DataTimeline extends DataArray {

  declare data: Timeline

}


export class DataTimelineArray extends DataArray {

  declare data: Timeline[]

}

